(() => {
  const PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'referrer_template', 'fbc', 'fbp', 'gclid', 'OutbrainClickId']
  const PART_PARAM_KEYS = ['trc_'];

  function handleTrackingIds() {
    const urlParams = new URLSearchParams(window.location.search);
    const newIds = [];
    const changedAttributes = {};

    urlParams.forEach((value, key) => {
      const isFullKey = PARAM_KEYS.includes(key);
      const isPartialKey = PART_PARAM_KEYS.some(prefix => key.startsWith(prefix));
      if (!isFullKey && !isPartialKey) return;

      newIds.push(key);
      changedAttributes[key] = value;
      setCookie(key, value);
    });

    const fbclid = urlParams.get('fbclid');
    const outbrainClickId = urlParams.get('OutbrainClickId');
    if (fbclid) {
      const fbc = generateFbc(fbclid);
      newIds.push('zuckClick');
      changedAttributes['zuckClick'] = fbc;
      setCookie('zuckClick', fbc);
    }

    if (outbrainClickId) {
      newIds.push('OutbrainClickId');
      changedAttributes['OutbrainClickId'] = outbrainClickId;
      setCookie('OutbrainClickId', outbrainClickId);
    }

    if (!getCookie('zuckBro')) {
      const fbp = generateFbp();
      newIds.push('zuckBro');
      changedAttributes['zuckBro'] = fbp;
      setCookie('zuckBro', fbp);
    }


    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('set_relevant_ids', { ids: newIds });
    }

    if (Object.keys(changedAttributes).length > 0) {
      updateCartAttributes(changedAttributes).then();
    }
  }

  function setupLinkTracking() {
    const links = document.querySelectorAll('a[href]');
    const dmnGroup = Array.isArray(window.theme?.dmn_group) ? window.theme.dmn_group : [];
    if (dmnGroup.length === 0) return;

    links.forEach(async link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }

      const isExternal = url.hostname !== window.location.hostname;
      if (!isExternal) return;

      const domain = url.hostname.replace(/^www\./, '');
      const hash = await sha256Hex(domain);
      if (!dmnGroup.includes(hash)) return;

      link.href = getTrackingUrl(url);
    });
  }

  function getTrackingUrl(baseUrl) {
    const referrerTemplate = window.theme?.template?.suffix ?? null;
    const params = new URLSearchParams();

    PARAM_KEYS.forEach(key => {
      const value = getCookie(key);
      if (value) params.set(key, value);
    });

    document.cookie.split(';').forEach(cookieStr => {
      const [rawName, rawValue] = cookieStr.split('=');
      const name = rawName?.trim();
      const value = decodeURIComponent(rawValue || '');
      if (PART_PARAM_KEYS.some(prefix => name.startsWith(prefix))) {
        params.set(name, value);
      }
    });

    const kameleoonCode = Kameleoon?.API?.Visitor?.code;
    if (kameleoonCode) {
      params.set('kameleoon_visitor_code', kameleoonCode);
    }

    const url = new URL(baseUrl);
    for (const [key, value] of params.entries()) {
      url.searchParams.set(key, value);
    }

    if (referrerTemplate) {
      url.searchParams.set('referrer_template', referrerTemplate);
    }

    return url.toString();
  }

  function generateFbc(fbclid) {
    const timestamp = Date.now();
    return `${timestamp}.${fbclid}`;
  }

  function generateFbp() {
    const timestamp = Date.now();
    const rand = (() => {
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        const buf = new Uint32Array(1);
        crypto.getRandomValues(buf);
        const n = (buf[0] % 9000000000) + 1000000000;
        return String(n);
      }
      return String(Math.floor(Math.random() * 9000000000) + 1000000000);
    })();

    return `${timestamp}.${rand}`;
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .map(c => c.split('='))
      .find(([key]) => key === name)?.[1] ?? null;
  }

  function setCookie(name, value, { days = 90 } = {}) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);

    let cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    if (location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  async function updateCartAttributes(attributes) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      body: JSON.stringify({
        attributes,
      }),
      keepalive: true,
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  async function sha256Hex(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  handleTrackingIds();
  setupLinkTracking();

  // Re-run link tracking when Kameleoon becomes available to include visitor code
  if (typeof Kameleoon !== 'undefined' && Kameleoon.API?.Visitor) {
    // Kameleoon already loaded, links are already set up with the code
  } else {
    window.addEventListener('Kameleoon::Started', function () {
      setupLinkTracking();
    });
  }
})()